// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsModalTableRow-moduleAttachServiceRequestsModalTableRow__P8H47 TableComponent-modulerow__xPAo4";
var _2 = "AttachServiceRequestsModalTableRow-modulearchivedIconContainer__ARCL1 EntityArchivedIcon-moduleentityArchivedIconContainer__u1fL2 IconNG-moduleiconContainer__SxWZ0";
var _3 = "AttachServiceRequestsModalTableRow-modulereadonly__rUcwF";
export { _1 as "AttachServiceRequestsModalTableRow", _2 as "archivedIconContainer", _3 as "readonly" }
